import { useMemo } from "react"
import { NavLink, Navigate, Outlet } from "react-router"

import { useAuth } from "@/auth/AuthProvider"
import { NavbarTabList, navbarTabClass } from "@/components/NavbarTabs"
import { useNavbarLeftAction, usePageTitle } from "@/layouts/pageChrome"

const TABS = [
  {
    to: "/tools/article-generator",
    label: "Article Generator",
    requiresArticleGenerator: true,
  },
  {
    to: "/tools/url-encoder",
    label: "URL Encoder",
    requiresArticleGenerator: false,
  },
] as const

/** Default Tools landing: Article Generator when allowed, else URL Encoder. */
export function ToolsIndexRedirect() {
  const { canUseArticleGenerator } = useAuth()
  return (
    <Navigate
      to={canUseArticleGenerator ? "article-generator" : "url-encoder"}
      replace
    />
  )
}

export default function ToolsPage() {
  usePageTitle("", "Tools")
  const { canUseArticleGenerator } = useAuth()
  const navbarTabs = useMemo(
    () => (
      <NavbarTabList>
        {TABS.filter(
          (tab) => !tab.requiresArticleGenerator || canUseArticleGenerator,
        ).map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) => navbarTabClass(isActive)}
          >
            {tab.label}
          </NavLink>
        ))}
      </NavbarTabList>
    ),
    [canUseArticleGenerator],
  )
  useNavbarLeftAction(navbarTabs)

  return (
    <div className="rounded-xl border border-[#4a4a4a] bg-[#2d2d2d] p-4 shadow-md sm:p-6">
      <Outlet />
    </div>
  )
}
